import Link from 'next/link';
import { cn } from '@/app/lib/utils';
import type { IFooterLogo as FooterLogoType } from '../interfaces';

export interface FooterLogoProps {
  imageUrl?: string;
  title?: string;
  link?: FooterLogoType['link'];
  className?: string;
}

export const FooterLogo = ({ imageUrl, title, link, className = '' }: FooterLogoProps) => {
  if (!imageUrl) return null;

  const logoImage = (
    <img src={imageUrl} alt={title || 'Footer Logo'} className="h-auto cursor-pointer" width={126} height={30} />
  );

  if (link?.url) {
    return (
      <Link
        href={link.url}
        target={link.isOpenInNewTab ? '_blank' : '_self'}
        rel={link.isOpenInNewTab ? 'noopener noreferrer' : undefined}
        className={cn('flex items-start justify-start', className)}
      >
        {logoImage}
      </Link>
    );
  }

  return <div className={cn('flex items-start justify-start', className)}>{logoImage}</div>;
};
